export default "__VITE_ASSET__DBygfiJZ__"